module.exports = __webpack_public_path__ + "media/W_S_I.05e819ca.mp3";